import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../App';
import { Button } from '../components/ui/button';
import { CheckCircle, Globe, ChevronRight } from 'lucide-react';

const CheckoutSuccess = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Auto-redirect countdown
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/dashboard');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="checkout-success">
      <div className="max-w-md w-full text-center">
        {/* Success Animation */}
        <div className="w-24 h-24 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-8 animate-pulse-glow">
          <CheckCircle className="w-12 h-12 text-emerald-600" />
        </div>

        {/* Logo */}
        <div className="flex items-center justify-center gap-2 mb-6">
          <div className="w-10 h-10 rounded-full gradient-emerald flex items-center justify-center">
            <Globe className="w-5 h-5 text-amber-500" />
          </div>
          <span className="font-bold text-xl text-emerald-900">Innovator Founder Visas</span>
        </div>

        {/* Content */}
        <h1 className="text-3xl font-bold text-slate-900 mb-4">
          Purchase Successful!
        </h1>
        <p className="text-lg text-slate-600 mb-8">
          Thank you for your purchase. Your account has been created and you now have full access to your course.
        </p>

        {/* User Info */}
        {user && (
          <div className="bg-white rounded-xl p-6 mb-8 border border-emerald-100 text-left">
            <p className="text-sm text-slate-500 mb-1">Logged in as:</p>
            <p className="font-semibold text-slate-900">{user.email}</p>
          </div>
        )}

        {/* CTA */}
        <Link to="/dashboard">
          <Button className="btn-primary text-lg px-8 py-4 w-full" data-testid="go-to-dashboard-btn">
            Go to Dashboard
            <ChevronRight className="w-5 h-5 ml-2" />
          </Button>
        </Link>

        <p className="text-sm text-slate-400 mt-4">
          Redirecting in {countdown} seconds...
        </p>
      </div>
    </div>
  );
};

export default CheckoutSuccess;
